import { IFrameHelper } from 'widget/helpers/utils';
import { createGreetingMessages } from '../helpers/utils';

export default {
  methods: {
    async cleanCurrentConversation() {
      await this.$store.dispatch('conversation/clearConversations');
      await this.$store.dispatch('conversationAttributes/set', {
        id: null,
        did: null,
        status: null,
        in_queue: undefined,
        customAttributes: null,
      });
      const {
        greetingEnabled,
        typebotGreetingEnabled,
      } = window.hooryWebChannel;

      if (greetingEnabled || typebotGreetingEnabled) {
        const msgs = createGreetingMessages();
        msgs.forEach(msg => {
          this.$store.dispatch('conversation/addOrUpdateMessage', msg);
        });
      }
    },

    async updateConversation({
      id,
      did,
      status,
      in_queue,
      archived,
      customAttributes,
      updateLastSeen,
    }) {
      // prevent duplicate calls
      if (window.isUpdatingConversation) return;

      window.isUpdatingConversation = true;
      await this.$store.dispatch('conversation/clearConversations');
      await this.$store.dispatch('conversation/setUserLastSeen');
      await this.$store.dispatch(
        'conversation/fetchCurrentConversationMessages',
        {
          conversation_id: id,
        }
      );

      // Read current conversation messages only if widget is open
      await this.$store.dispatch('conversation/readConversationMessages', {
        conversationId: did,
      });

      IFrameHelper.sendMessage({
        event: 'onConversationOpen',
        data: {
          conversationId: id,
          conversationDisplayId: did,
        },
      });

      await this.$store.dispatch('conversationAttributes/set', {
        id,
        did,
        status,
        in_queue,
        archived,
        customAttributes,
      });

      setTimeout(() => {
        window.isUpdatingConversation = false;
      }, 200);

      if (updateLastSeen) {
        await this.$store.dispatch('conversation/setUserLastSeen');
      }
    },
  },
};
